<template>
  <a v-if="file && file_data" class="link" target="_blank" rel="noreferrer" :href="file_data.data.data.full_url">Learn More</a>
</template>

<script>
import useSWRV from "swrv";
import api from "../services/api";

export default {
  name: "JobFileUpload",
  props: {
    file: {
      type: Number,
      default: null
    }
  },
  setup(props) {
    const {
      data: file_data,
      error: file_error
    } = useSWRV(() => `/files/${props.file}?status=published`, api.fetcher);
    return {
      file_data,
      file_error
    }
  },
}
</script>
